import { LocationCardProps } from '@ahc-digital/component-library';
import { LocationData as SitecoreLocationData } from './LocationData.types';
import { useConditionalRendering } from './useConditionalRendering';
import { ReactElement } from 'react';

// todo: import LocationData directly from @ahc-digital/component-library
// when it becomes available.
type ComponentLibraryLocationData = LocationCardProps['location'];

export function CreateLocationDataModel(
  props?: SitecoreLocationData
): ComponentLibraryLocationData {
  const { renderImage, renderLink } = useConditionalRendering();
  const { fields } = props || {};

  return {
    addressLine1: fields?.AddressLine1?.value ?? '',
    addressLine2: fields?.AddressLine2?.value,
    city: fields?.City?.value,
    defaultPhone: fields?.DefaultPhone?.value,
    email: fields?.Email?.value,
    emergencyPhone: fields?.EmergencyPhone?.value,
    hoursOfOperation: fields?.HoursOfOperation?.value,
    image: renderImage(fields?.Image, { required: true }) as ReactElement,
    latitude: fields?.Latitude?.value,
    locationDetailPage: renderLink(fields?.LocationDetailPage),
    locationName: fields?.LocationName?.value ?? '',
    locationTour: renderLink(fields?.LocationTour),
    locationType: fields?.LocationType?.fields?.Value
      ?.value as ComponentLibraryLocationData['locationType'],
    longitude: fields?.Longitude?.value,
    servicesAvailable: fields?.ServicesAvailable?.value,
    state: fields?.State?.value,
    zip: fields?.Zip?.value,
  };
}
